import React from 'react';
import Link from 'next/link';

import DropdownItem from './DropdownItem';
import { dropdownItems } from './Content';

const NavMobile = ({ theme, navResponsive }) => (
  <div>
    <h4 className={`${theme.dropdown.title} block uppercase text-xs tracking-wider`}>Products</h4>
    <ul className={`grid grid-cols-2 gap-y-4 mt-4 pb-4 border-b ${theme.dropdown.border}`}>
      <div className="space-y-4">
        {dropdownItems.products.section1.row1.content.map(item => (
          <DropdownItem
            key={item.title}
            href={item.href}
            icon={item.icon}
            title={item.title}
            text={item.text}
            colors={theme.dropdown.items}
            itemType={item.type}
            navResponsive={navResponsive}
          />
        ))}
        {dropdownItems.products.section1.row2.subContent.map(item => (
          <DropdownItem
            key={item.title}
            href={item.href}
            icon={item.icon}
            title={item.title}
            text={item.text}
            colors={theme.dropdown.items}
            itemType={item.type}
            navResponsive={navResponsive}
          />
        ))}
        {dropdownItems.products.section3.row1.content.map(item => (
          <DropdownItem
            key={item.title}
            href={item.href}
            icon={item.icon}
            title={item.title}
            text={item.text}
            colors={theme.dropdown.items}
            itemType={item.type}
            navResponsive={navResponsive}
          />
        ))}
      </div>

      <div className="space-y-4">
        {dropdownItems.products.section2.row1.content.map(item => (
          <DropdownItem
            key={item.title}
            href={item.href}
            icon={item.icon}
            title={item.title}
            text={item.text}
            colors={theme.dropdown.items}
            itemType={item.type}
            navResponsive={navResponsive}
          />
        ))}
        {dropdownItems.products.section2.row2.subContent.map(item => (
          <DropdownItem
            key={item.title}
            href={item.href}
            icon={item.icon}
            title={item.title}
            text={item.text}
            colors={theme.dropdown.items}
            itemType={item.type}
            navResponsive={navResponsive}
          />
        ))}
        {dropdownItems.products.section2.row3.content.map(item => (
          <DropdownItem
            key={item.title}
            href={item.href}
            icon={item.icon}
            title={item.title}
            text={item.text}
            colors={theme.dropdown.items}
            itemType={item.type}
            navResponsive={navResponsive}
          />
        ))}
      </div>
    </ul>
    <h4 className={`${theme.dropdown.title} block mt-4 uppercase text-xs tracking-wider`}>
      Solutions
    </h4>
    <ul
      className={`grid grid-cols-2 gap-y-4 mt-4 pb-4 border-b ${theme.dropdown.border}`}
      style={{ gridTemplateColumns: '52% 48%' }}
    >
      {dropdownItems.solutions.industries.content.map(item => (
        <DropdownItem
          key={item.title}
          href={item.href}
          icon={item.icon}
          title={item.title}
          text={item.text}
          colors={theme.dropdown.items}
          itemType={item.type}
          navResponsive={navResponsive}
        />
      ))}
      {dropdownItems.solutions.useCases.content.map(item => (
        <DropdownItem
          key={item.title}
          href={item.href}
          icon={item.icon}
          title={item.title}
          text={item.text}
          colors={theme.dropdown.items}
          itemType={item.type}
          navResponsive={navResponsive}
        />
      ))}
    </ul>
    <h4 className={`${theme.dropdown.title} block mt-4 uppercase text-xs tracking-wider`}>
      Resources
    </h4>
    <ul
      className={`grid grid-cols-2 gap-y-4 mt-4 pb-4 border-b ${theme.dropdown.border}`}
      style={{ gridTemplateColumns: '52% 48%' }}
    >
      {dropdownItems.resources.map(item => (
        <DropdownItem
          key={item.title}
          href={item.href}
          icon={item.icon}
          title={item.title}
          text={item.text}
          colors={theme.dropdown.items}
          itemType={item.type}
          navResponsive={navResponsive}
        />
      ))}
    </ul>
    <h4 className={`${theme.dropdown.title} block mt-4 uppercase text-xs tracking-wider`}>
      Company
    </h4>
    <ul
      className={`grid grid-cols-2 gap-y-4 mt-4 pb-4 border-b ${theme.dropdown.border}`}
      style={{ gridTemplateColumns: '53% 47%' }}
    >
      {dropdownItems.company.map(item => (
        <DropdownItem
          key={item.title}
          href={item.href}
          icon={item.icon}
          title={item.title}
          text={item.text}
          colors={theme.dropdown.items}
          itemType={item.type}
          navResponsive={navResponsive}
        />
      ))}
    </ul>

    <h4 className={`${theme.dropdown.title} block mt-4 uppercase text-xs tracking-wider`}>
      Customers
    </h4>
    <ul className="grid grid-cols-2 mt-4 gap-y-4" style={{ gridTemplateColumns: '53% 47%' }}>
      {dropdownItems.customers.mobile.map(item => (
        <DropdownItem
          key={item.title}
          href={item.href}
          icon={item.icon}
          title={item.title}
          text={item.text}
          colors={theme.dropdown.items.solid}
          itemType={item.type}
          navResponsive={navResponsive}
        />
      ))}
    </ul>
    <Link href="/customers" className="inline-block mt-4 text-xs">
      See all customers
    </Link>
  </div>
);

export default NavMobile;
